export const isConnected = ({ connectivity }) => connectivity.isConnected
